import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { setupIonicReact } from "@ionic/react";

/* Ionic core CSS — custom properties only (safe to import globally) */
import "@ionic/react/css/core.css";

/* Ionic utility classes used inside admin */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";

import "@/index.css";
import App from "@/App";
import { startIonicServicesOnce } from "@/utils/ionAppOnce";
import { installRequiredFieldHighlight } from "@/utils/requiredFields";

/* Initialize Ionic — MD mode for consistent web/desktop styling */
setupIonicReact({ mode: "md" });
// every page mounts its own IonApp; Ionic's global services start only once
startIonicServicesOnce();
// a required field left empty on blur turns red, in every generator form
installRequiredFieldHighlight();

const root = ReactDOM.createRoot(document.getElementById("root"));
// NOTE: React.StrictMode intentionally removed — it double-mounts effects in
// development, which makes sonner's <Toaster> render every toast twice.
root.render(
  <HelmetProvider>
    <App />
  </HelmetProvider>,
);
